import { Stack, Typography, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";
import { BaseBTN } from "src/components/ui";
import EducationWrapper from "src/components/ui/education-wrapper/EducationWrapper";

const EducationPage = () => {
  const theme = useTheme();
  const exampleHash = "hhg6aj9";
  const { combined } = useParams();
  const videoHash = combined?.split("-")[0];
  const slug = combined?.split("-").slice(1).join("-");

  function deslugify(slug) {
    return slug.replace(/-/g, " ");
  }
  const title = deslugify(slug);

  function closeThisTab() {
    window.close();
  }

  return (
    <EducationWrapper>
      <Stack flexDirection={"column"} width={"100%"} justifyContent={"center"} px={2} gap={3}>
        <Typography fontSize={28} fontWeight={600} textAlign={"center"}>
          محتوای آموزشی
        </Typography>
        <Stack p={2} bgcolor={"grey.gs"} borderRadius={2} gap={2}>
          <Typography color={theme.palette.primary.main} variant="title" fontWeight={600}>
            {title}
          </Typography>
          <Stack bgcolor={"grey.gb"} p={5} borderRadius={2}>
            <Stack
              bgcolor={"grey.gb"}
              p={5}
              justifyContent={"center"}
              alignItems={"center"}
              borderRadius={2}
              sx={{
                position: "relative",
                paddingBottom: "53.5%",
                // aspectRatio: "16 / 9",
                height: 0,
                overflow: "hidden",
              }}
            >
              <iframe
                title="aparat"
                src={`https://www.aparat.com/video/video/embed/videohash/${videoHash || exampleHash}/vt/frame`}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
                allowFullScreen
              />
            </Stack>
          </Stack>
          <BaseBTN onClick={closeThisTab} sx={{ display: { xs: "flex", sm: "none" } }}>
            بستن
          </BaseBTN>
          <Stack flexDirection={"row"} gap={1} p={2}>
            <Typography color={"grey.gm"} variant="h6">
              ©
            </Typography>
            <Typography color={"grey.gm"} variant="body2" sx={{ pt: 0.6 }}>
              تمام حقوق مادی و معنوی این محتوا متعلق به شرکت فناوری اطلاعات فراهوش‌کام است و هرگونه تکثیر، توزیع و
              انتشار بدون اجازه، پیگرد قانونی دارد.
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </EducationWrapper>
  );
};
export default EducationPage;
